import HTTP from './axios';

const ProfessionalService = {
  searchProfessional: crmOrName => HTTP.post('/professionals/search', { crmOrName }).then(response => response.data.data),
};

export default ProfessionalService;
